import type {CanvasFollowUpOrigin} from '@shared/canvasFollowUp';
import type {CanvasChatMessage} from './canvas-types';
export interface CanvasFollowUp {
 label:string;action:'angles'|'brief'|'script'|'report'|'images'|'plan';
 id?:number;title?:string;content?:string;imageIds?:string[];value?:string;origin?:CanvasFollowUpOrigin;
}
/** Actions belong to this response's saved artifacts, never a global last-run menu. */
export function canvasFollowUps(message:CanvasChatMessage,images:Array<{id:string;src:string;workflowRunId?:number|null}>,request:string,projectId?:number|null):CanvasFollowUp[]{
 if(message.role!=='assistant'||message.isStreaming||message.playbookJobs?.some(job=>job.status==='queued'||job.status==='running')||(message.playbookProgress&&!message.playbookProgress.isDone))return [];
 const actions:CanvasFollowUp[]=[];
 const set=message.angleSetCard;
 if(set)actions.push({label:'Review Concepts',action:'angles',id:set.setId,title:set.title});
 const brief=message.playbookProgress?.campaignBrief;
 if(brief)actions.push({label:'Review campaign brief',action:'brief',title:brief.title,content:brief.content});
 if(message.videoScriptCard)actions.push({label:'Review & build this video',action:'script',id:message.videoScriptCard.draftId,title:message.videoScriptCard.title});
 if(message.webResearchReport)actions.push({label:'Review research findings',action:'report',title:'Research findings',content:message.webResearchReport});
 else if(message.sidebarDoc)actions.push({label:'Open this write-up',action:'report',title:message.sidebarDoc.title,content:message.sidebarDoc.content});
 return actions.slice(0,3);
}
